module.exports = __webpack_public_path__ + "img/banner@video.d2a26205.png";